export const concatPhone = (prefix: number, phone: number) =>
  `+${prefix}${phone}`
